import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ResourceType, type ChecklistRelatedItem} from "../../types";
import {buildChecklistDocHref, buildTopicHref} from "../checklistRefUrl";
import {useChecklistStructure} from "../ChecklistDataContext";
import {useContentParams} from "../../router";
import IconExternalLink from "../../../../assets/external-link.svg?react";
import styles from "./refCard.module.css";

export const DocumentGeneratorRefCard = ({
    relatedItem,
}: {
    relatedItem: ChecklistRelatedItem;
}) => {
    const {t} = useTranslation();
    const {topicType, topicName} = useContentParams();
    const {collectionData, checklistConfig} = useChecklistStructure();
    // Derive the base path from named route params + checklist metadata (the
    // same construction as ChecklistResource), not positional path slicing.
    const checklistBasePath = `/${topicType}/${topicName}/${checklistConfig.metadata.topicId}`;

    switch (relatedItem.resourceTypeId) {
        case ResourceType.documentGenerator: {
            const url = buildChecklistDocHref(
                relatedItem,
                checklistBasePath,
                collectionData,
            );
            return (
                <Link to={url} className={styles.refCard}>
                    <span className={styles.refBadge}>
                        {t("Word.Template")}
                    </span>
                    <span className={styles.refLabel}>{relatedItem.name}</span>
                </Link>
            );
        }

        case ResourceType.checklist: {
            const url = buildTopicHref(relatedItem);
            return (
                <Link to={url} className={styles.refCard}>
                    <IconExternalLink
                        aria-hidden="true"
                        className={styles.externalLinkIcon}
                    />
                    <span className={styles.refLabel}>{relatedItem.name}</span>
                </Link>
            );
        }

        default:
            return null;
    }
};
